module.exports = __webpack_public_path__ + "static/media/11.d99bd8eb.svg";